"use strict";

/* eslint-disable no-console */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasScope = exports.hasGate = exports.getScopes = void 0;

var _reselect = require("reselect");

var _propSelectors = require("./propSelectors");

var _utilityFunctions = require("../util/utilityFunctions");

var warnBadGroup = function warnBadGroup(groupName) {
  return console.warn("default permission-components selector did not get viable permission group for " + groupName + ". Make sure your store is correctly structured or write your own selectors.");
};

var getAttribute = function getAttribute(objectOrImmutable, attributeName) {
  if ((0, _utilityFunctions.isFunction)(objectOrImmutable.get)) {
    return objectOrImmutable.get(attributeName);
  }

  return objectOrImmutable[attributeName];
};

var getScopes = function getScopes(state) {
  var auth = getAttribute(state, 'auth');

  if (auth) {
    var user = getAttribute(auth, 'user');

    if (user) {
      return getAttribute(user, 'scopes');
    }
  }

  return null;
};

exports.getScopes = getScopes;

var getGates = function getGates(state) {
  var auth = getAttribute(state, 'auth');

  if (auth) {
    return getAttribute(auth, 'gates');
  }

  return null;
};

var makePermissionSelector = function makePermissionSelector(groupName, groupSelector) {
  return (0, _reselect.createSelector)([groupSelector, _propSelectors.getPermissionName], function (group, value) {
    if (group && (0, _utilityFunctions.isFunction)(group.includes)) {
      return group.includes(value);
    }

    warnBadGroup(groupName);
    return false;
  });
};

var hasGate = makePermissionSelector('gates', getGates);
exports.hasGate = hasGate;
var hasScope = makePermissionSelector('scopes', getScopes);
exports.hasScope = hasScope;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/permission-components/static-1.43/js/selectors/defaultSelectors.js
// module id = 664
// module chunks = 209 210 211 212